"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Image360Item = void 0;
var _react = _interopRequireDefault(require("react"));
var _Gallery = require("b2b-components/theme/components/Gallery");
var _Item = require("../Item");
var Image360Item = function Image360Item(_ref) {
  var image360 = _ref.image360,
    imageUrl = _ref.imageUrl,
    title = _ref.title,
    className = _ref.className,
    isCurrent = _ref.isCurrent,
    isPreview = _ref.isPreview,
    onClick = _ref.onClick,
    totalItemCount = _ref.totalItemCount,
    href = _ref.href;
  var images360Normal = image360.base.map(function (image) {
    return imageUrl + image;
  }).join(' ');
  var images360Zoom = image360.zoom.map(function (image) {
    return imageUrl + image;
  }).join(' ');
  return /*#__PURE__*/_react["default"].createElement(_Item.Item, {
    className: className,
    isPreview: isPreview,
    isCurrent: isCurrent,
    onClick: onClick,
    totalItemCount: totalItemCount,
    href: href,
    type: _Gallery.GALLERY_ITEM_TYPE.image360
  }, /*#__PURE__*/_react["default"].createElement("a", {
    className: "Magic360",
    "data-options": "\n          columns: 16;\n          images: ".concat(images360Normal, ";\n          large-images: ").concat(images360Zoom, ";\n        ")
  }, /*#__PURE__*/_react["default"].createElement("img", {
    alt: title,
    src: "".concat(imageUrl).concat(image360.base[0]),
    title: title
  })));
};
exports.Image360Item = Image360Item;